export const T = {
  en_GB: {
    general: "General",
    suitability: "Suitability",
    documents: "Documents",
    assetClasses: "Asset Classes",
    cost: "Cost",
  },
  nb_NO: {
    general: "Generelt",
    suitability: "Egnethet",
    documents: "Dokumenter",
    assetClasses: "Aktivaklasser",
    cost: "Kostnad",
  },
} as const;
